import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/gestion_proyecto/actividadManoObra';
import Actividades from './ActividadList';


const ms2p = (state) => {
  return {
    ...state.proyecto_actividad_mano_obra,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Actividades);
